export const capitalizeFirstLetter = (string) => {
  if (!string) return string;
  return string
    .split(/[_ -]/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
